// import Swiper JS
import Swiper from "swiper/bundle";
import "core-js/features/number";
import "core-js/features/string/repeat";

const swiper = new Swiper(".sidescroll-widget__swiper", {
  effect: "slide",
  spaceBetween: 10,
  freeMode: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  a11y: {
    enabled: true,
    prevSlideMessage: Drupal.t("Previous image"),
    nextSlideMessage: Drupal.t("Next image"),
  },
});
